import React from "react";

// Diagonal corner ribbon; parent must be `relative overflow-hidden`.
export const LaunchRibbon = ({ label = "Launch Price", testId = "launch-ribbon" }) => (
  <div className="absolute top-0 left-0 w-28 h-28 overflow-hidden pointer-events-none z-10" aria-hidden="false" data-testid={testId}>
    <span className="absolute block w-44 text-center -rotate-45 -left-12 top-6 bg-[#C8102E] text-white text-[11px] font-display font-bold tracking-wide uppercase py-1.5 shadow-md">
      {label}
    </span>
  </div>
);
